import { render, staticRenderFns } from "./ContentBlocksList.vue?vue&type=template&id=7b8c4146"
import script from "./ContentBlocksList.js?vue&type=script&lang=js&external"
export * from "./ContentBlocksList.js?vue&type=script&lang=js&external"
import style0 from "./ContentBlocksList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports